import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUserContext } from '@/auth/UserContext';
import { HeaderCard } from '@/components/Cards/HeaderCard';
import { HomeworksModal } from '@/components/HomeworksModal';
import { ScheduledTestsModal } from '@/components/ScheduledTestsModal';
import { HeaderCardIcon } from '@/types/components';

interface Props {
  isCompact?: boolean;
}

export const DiaryActionCards: React.FC<Props> = ({ isCompact = false }) => {
  const { t } = useTranslation();
  const { user } = useUserContext();
  const [isHomeworksOpen, setIsHomeworksOpen] = useState(false);
  const [isTestScheduleOpen, setIsTestScheduleOpen] = useState(false);
  const isTestSchedulerEnabled =
    user?.userSettings?.isTestSchedulerEnabled ?? false;

  return (
    <>
      <HeaderCard
        label={t('diary.homeworkCard')}
        icon={isCompact ? undefined : HeaderCardIcon.Homework}
        bgClassName="bg-yellow-soft"
        isCompact={isCompact}
        onClick={() => setIsHomeworksOpen(true)}
      />

      {isTestSchedulerEnabled && (
        <HeaderCard
          label={t('diary.testScheduleCard')}
          icon={isCompact ? undefined : HeaderCardIcon.TestSchedule}
          iconClassName="size-9"
          iconGapClassName="gap-1.5"
          bgClassName="bg-green-soft"
          isCompact={isCompact}
          onClick={() => setIsTestScheduleOpen(true)}
        />
      )}

      {isHomeworksOpen && (
        <HomeworksModal onClose={() => setIsHomeworksOpen(false)} />
      )}

      {isTestScheduleOpen && (
        <ScheduledTestsModal
          isOpen
          onClose={() => setIsTestScheduleOpen(false)}
        />
      )}
    </>
  );
};
